import { ChatRecordProperty } from '@indigohive/cogfy-types'
import clsx from 'clsx'
import { t } from 'i18next'
import { MessageSquareIcon } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useCogfy, useWorkspaceSlug } from '../../../hooks'
import { FieldCellProps } from '../FieldCell'
import { PreviewChatContent } from './PreviewChatContent'
import { useMutation } from '@tanstack/react-query'

export function ChatCell (props: FieldCellProps<ChatRecordProperty>) {
  const { collectionId, record, field, textWrap, property } = props
  const cogfy = useCogfy()
  const navigate = useNavigate()
  const workspace = useWorkspaceSlug()

  const chatId = property?.chat?.value?.chatId
  const lastMessage = property?.chat?.value?.lastMessage
  const date = lastMessage?.sendDate

  const createChat = useMutation({
    mutationFn: async () => {
      return await cogfy.createChat({ recordId: record.id, fieldId: field.id, collectionId })
    },
    onSuccess: newChat => {
      navigate(`/${workspace}/chats/${newChat.id}`)
    }
  })

  return (
    <>
      {lastMessage?.content && lastMessage.role && (
        <PreviewChatContent
          to={`/${workspace}/chats/${chatId}`}
          date={date}
          lastMessage={lastMessage}
          textWrap={textWrap}
          chatProvider={property?.chat.value?.provider}
        />
      )}

      {!(lastMessage?.content && lastMessage.role) && (
        <div
          className={clsx(
            'h-full',
            'w-full',
            'px-2',
            'py-1',
            'flex',
            'items-start',
            'hover:bg-base-200',
            'active:bg-base-300',
            'gap-1',
            'text-gray-600',
            !textWrap && 'truncate'
          )}
          onClick={() => {
            if (chatId) {
              navigate(`/${workspace}/chats/${chatId}`)
            } else {
              createChat.mutate()
            }
          }}
        >
          <div className="grow line-clamp-2">
            <span className="font-medium text-gray-600 inline-flex gap-1.5 items-center mr-1">
              <MessageSquareIcon size={12} />
              {chatId ? t('View chat') : t('Start chat')}
            </span>
          </div>
        </div>
      )}
    </>
  )
}
